/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2024] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';

import lazyLoadView from '@/util/lazyLoadView';

import SearchInProgressCustomerOrders from '../../services/SearchInProgressCustomerOrders';
import loadSearchFields from '../../../login/loaders/SearchFieldsViewLoader';

import tmplRelocationSearchView from './RelocationSearchView.hbs';

const RelocationSearchView = View.extend({
  template: tmplRelocationSearchView,

  ui: {
    searchFieldsView: '.search-fields-view',
    searchCardContainer: '.search-card-container'
  },

  regions: {
    searchFieldsView: '@ui.searchFieldsView',
    searchCardContainer: '@ui.searchCardContainer'
  },

  events: {},

  childViewEvents: {
    'search:response': 'onSearchResponse'
  },

  onRender() {
    const searchFields = [
      {
        id: 'order-number-search-field',
        name: 'customerOrderID',
        class: 'InputSearchField',
        placeholder: 'Order Number'
      },
      {
        id: 'serial-number-search-field',
        name: 'serialNumber',
        class: 'InputSearchField',
        placeholder: 'Serial Number'
      }
    ];

    this.showChildView(
      'searchFieldsView',
      lazyLoadView(() => loadSearchFields(searchFields, SearchInProgressCustomerOrders))
    );
  },

  onSearchResponse(response) {
    this.trigger('search:response', response);
  }
});

export default RelocationSearchView;
